import { Link } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'
import confirmationImage from '../assets/confirmation.png'

const QuoteConfirmation = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container-custom py-16">
        <div className="card text-center max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-3">Demande envoyée</h1>
          <img 
            src={confirmationImage} 
            alt="Demande envoyée" 
            className="h-48 w-auto mx-auto mb-3"
          />
          <p className="text-gray-700 mb-6">
            L'équipe Flightcase vous remercie de l'avoir sollicité pour votre projet !
            Nous reviendrons dans les plus brefs délais !
          </p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/catalogue-materiels" className="btn-primary">Retour au catalogue</Link>
            <Link to="/account/reservations" className="btn-secondary">Mes réservations</Link>
            <Link to="/" className="btn-secondary">Accueil</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuoteConfirmation


